import { render } from "./articlePage.vue?vue&type=template&id=16a9ae5c&scoped=true"
import script from "./articlePage.vue?vue&type=script&lang=js"
export * from "./articlePage.vue?vue&type=script&lang=js"

import "./articlePage.vue?vue&type=style&index=0&id=16a9ae5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a9ae5c"]])

export default __exports__